import { getBackendUrl } from '../utils/apiConfig';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
  'Content-Type': 'application/json',
});

export const contentAPI = {
  getPublic: async () => {
    const response = await fetch(`${getBackendUrl()}/api/content/public`);
    if (!response.ok) throw new Error('Impossible de charger le contenu du site');
    return response.json();
  },

  updateSection: async (section, data) => {
    const response = await fetch(`${getBackendUrl()}/api/content/admin/${section}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify({ data }),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.detail || 'Erreur de sauvegarde');
    }
    return response.json();
  },

  createPinball: async (machine) => {
    const response = await fetch(`${getBackendUrl()}/api/content/admin/pinball-machines`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(machine),
    });
    if (!response.ok) throw new Error('Erreur lors de l\'ajout du flipper');
    return response.json();
  },

  updatePinball: async (id, machine) => {
    const response = await fetch(`${getBackendUrl()}/api/content/admin/pinball-machines/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(machine),
    });
    if (!response.ok) throw new Error('Erreur lors de la mise à jour du flipper');
    return response.json();
  },

  deletePinball: async (id) => {
    const response = await fetch(`${getBackendUrl()}/api/content/admin/pinball-machines/${id}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    if (!response.ok) throw new Error('Erreur lors de la suppression');
    return response.json();
  },
};

export const coachesAPI = {
  getAll: async (activeOnly = false) => {
    const response = await fetch(`${getBackendUrl()}/api/coaches/?active_only=${activeOnly}`);
    if (!response.ok) throw new Error('Impossible de charger les coachs');
    return response.json();
  },

  create: async (coach) => {
    const response = await fetch(`${getBackendUrl()}/api/coaches/`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(coach),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.detail || 'Erreur création coach');
    }
    return response.json();
  },

  update: async (id, coach) => {
    const response = await fetch(`${getBackendUrl()}/api/coaches/${id}`, {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify(coach),
    });
    if (!response.ok) throw new Error('Erreur mise à jour coach');
    return response.json();
  },

  delete: async (id) => {
    const response = await fetch(`${getBackendUrl()}/api/coaches/${id}`, {
      method: 'DELETE',
      headers: authHeaders(),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.detail || 'Erreur suppression coach');
    }
    return response.json();
  },
};

export default contentAPI;
